// Candidate form event handlers using event delegation
// This allows handlers to work on dynamically loaded AJAX content

(function() {
  // Handle confirmation dialogs for candidate type changes (university visits)
  document.addEventListener("change", function(event) {
    const target = event.target;
    if (target.matches("#candidate_intern.university")) {
      if (!confirm("Are you sure you want to change the candidate type? They will be moved into the regular candidate console and no longer appear under this University Visit")) {
        event.preventDefault();
        event.stopImmediatePropagation();
        // Revert the select to its original value
        if (target.dataset.originalValue !== undefined) {
          target.value = target.dataset.originalValue;
        }
      }
    }
  }, true);

  // Handle confirmation dialogs for candidate type changes (regular)
  document.addEventListener("change", function(event) {
    const target = event.target;
    if (target.matches("#candidate_intern.regular")) {
      if (!confirm("Are you sure you want to change the candidate type?")) {
        event.preventDefault();
        event.stopImmediatePropagation();
        // Revert the select to its original value
        if (target.dataset.originalValue !== undefined) {
          target.value = target.dataset.originalValue;
        }
      }
    }
  }, true);

  // Store original values for selects that need confirmation
  document.addEventListener("focus", function(event) {
    const target = event.target;
    if (target.matches("#candidate_intern.university, #candidate_intern.regular")) {
      target.dataset.originalValue = target.value;
    }
  }, true);

  // Submit remote_form on change for inputs, textareas, selects
  document.addEventListener("change", function(event) {
    const input = event.target;
    const form = input.closest(".remote_form");
    
    if (!form) return;
    
    // Skip if this is being handled by another handler that prevented default
    if (event.defaultPrevented) return;
    
    // Add loading gif after the input
    addLoadingIndicator(input);
    
    // Submit the form using Rails UJS
    if (window.Rails && Rails.fire) {
      Rails.fire(form, "submit");
    } else {
      form.submit();
    }
  });

  // Show submit button when schedule file is selected
  document.addEventListener("change", function(event) {
    const target = event.target;
    if (target.matches("#schedule_comment #comment_attachment")) {
      const submitBtn = document.querySelector("#submit-schedule");
      if (submitBtn) {
        submitBtn.classList.remove("hidden");
      }
    }
  });

  // Only remove loading indicators on ajax:error
  // On success, the server response (update.js.erb) handles changing the loading gif to a checkmark
  document.addEventListener("ajax:error", function(event) {
    removeLoadingIndicators(event.target);
  });

  // Helper function to add loading indicator
  function addLoadingIndicator(input) {
    // Remove any existing loading indicators first
    const existingLoader = input.parentNode.querySelector("img.loading");
    if (existingLoader) {
      existingLoader.remove();
    }
    
    // Create and add loading gif
    const img = document.createElement("img");
    img.src = window.loadingGifPath || "/assets/ajax.gif";
    img.className = "loading";
    img.style.verticalAlign = "middle";
    input.insertAdjacentElement("afterend", img);
  }

  // Helper function to remove loading indicators
  function removeLoadingIndicators(form) {
    if (!form) return;
    const loaders = form.querySelectorAll("img.loading");
    loaders.forEach(function(loader) {
      loader.remove();
    });
  }

})();
